import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { api } from "../../lib/api";

const FIELDS = [
  ["full_name", "Full name", "text", "Grace Achieng"],
  ["sacco_name", "SACCO name", "text", "Harambee SACCO"],
  ["role", "Your role", "text", "Credit Manager"],
  ["email", "Email address", "email", "you@sacco.co.ke"],
  ["phone", "Phone number", "tel", "+254 7XX XXX XXX"],
];
const MEMBER_BANDS = [["under_500", "Under 500"], ["500_2000", "500–2,000"], ["2000_10000", "2,000–10,000"], ["over_10000", "Over 10,000"]];
const INPUT = "mt-1.5 w-full rounded-lg border border-neutral-300 bg-white px-3.5 py-3 text-sm outline-none transition-[border-color,box-shadow] focus:border-[#0A8B85] focus:ring-2 focus:ring-[#0A8B85]/20";

export const SaccoDemoForm = ({ manualHours = "" }) => {
  const [form, setForm] = useState({ full_name: "", sacco_name: "", role: "", email: "", phone: "", members: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/public/sacco-demo-requests", { ...form, manual_vetting_hours: manualHours || null });
      setDone(true);
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Something went wrong — please try again.");
    }
    setBusy(false);
  };

  return (
    <section id="sacco-demo-form" className="mx-auto max-w-6xl scroll-mt-6 px-5 py-20 sm:py-24" data-testid="sacco-demo-form">
      <div className="grid gap-10 lg:grid-cols-[1fr_1.2fr] lg:gap-16">
        <div>
          <p className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-[#0A8B85]">Book a demo</p>
          <h2 className="mt-3 text-3xl font-extrabold text-[#0B2A28] sm:text-4xl" data-testid="sacco-form-heading">Let's talk about your SACCO</h2>
          <p className="mt-4 text-base leading-relaxed text-neutral-600 md:text-lg" data-testid="sacco-form-subheading">
            Tell us about your SACCO and we will be in touch within one business day to confirm your demo.
          </p>
        </div>
        <div className="rounded-3xl border border-neutral-200 bg-white p-6 shadow-[0_24px_60px_-30px_rgba(11,42,40,0.35)] sm:p-8" data-testid="sacco-form-card">
          {done ? (
            <div className="py-6 text-center" data-testid="sacco-form-success">
              <CheckCircle2 className="mx-auto h-12 w-12 text-[#0A8B85]" />
              <p className="mt-4 text-base font-bold text-[#0B2A28] md:text-lg">
                Thank you — we will be in touch within one business day to confirm your demo.
              </p>
            </div>
          ) : (
            <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2">
              {FIELDS.map(([k, label, type, ph]) => (
                <label key={k} className={k === "full_name" || k === "sacco_name" ? "block sm:col-span-2" : "block"}>
                  <span className="text-xs font-semibold uppercase tracking-wide text-neutral-500">{label} <span className="text-[#D4A83A]">*</span></span>
                  <input type={type} required value={form[k]} onChange={set(k)} placeholder={ph} className={INPUT} data-testid={`sacco-input-${k}`} />
                </label>
              ))}
              <label className="block sm:col-span-2">
                <span className="text-xs font-semibold uppercase tracking-wide text-neutral-500">Number of active members <span className="text-neutral-400">(optional)</span></span>
                <select value={form.members} onChange={set("members")} className={INPUT} data-testid="sacco-input-members">
                  <option value="">Select a range</option>
                  {MEMBER_BANDS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              </label>
              {err && <p className="text-sm text-red-600 sm:col-span-2" data-testid="sacco-form-error">{err}</p>}
              <button type="submit" disabled={busy}
                className="mt-2 w-full rounded-full bg-[#0A8B85] px-6 py-3.5 text-sm font-extrabold text-white transition-[background-color,transform] hover:-translate-y-0.5 hover:bg-[#0C9F97] disabled:opacity-50 sm:col-span-2"
                data-testid="sacco-form-submit">
                {busy ? "Sending…" : "Book a demo for your SACCO today"}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};
